<template>
  <div class="is-flex">
    <div class="suggested_positions">
      <button class="button is-info box" @click="setSkillsBooster">Set Skills Booster</button>
      <div>
        <p class="has-text-weight-bold">הצעות למשרות</p>
        <div v-if="suggestedPositions.length">
          <ApplicantSuggestedPosition
            v-for="suggestedPosition in suggestedPositions"
            :key="suggestedPosition.id"
            :applicant="payload.data"
            :position="suggestedPosition"
            class="faded_border_bottom"
          />
        </div>
        <p v-else class="no_suggested_positions_text">אין הצעות למשרות</p>
      </div>
    </div>
    <div>
      <div>
        <div class="is-flex is-justify-content-space-between is-align-items-flex-end">
          <BaseInput type="text" v-model="searchSkill" label="חיפוש סקילס :" />
          <button @click="revokeSkills" class="button is-danger">Revoke all skills</button>
        </div>
        <br />
        <p><b>With comments</b></p>
        <table class="table is-fullwidth">
          <tbody>
            <tr v-for="skill in skillsWithComments" :key="skill.id">
              <td>
                <ApplicantSkill :applicant_id="payload.data.resource_id" :applicant_skill="skill" :inputType="true" @refresh="init" />
              </td>
              <td>{{ skill.applicant_comment }}</td>
            </tr>
          </tbody>
        </table>
        <p><b>Featured</b></p>
        <div class="is-flex is-align-items-center is-flex-wrap-wrap">
          <div v-for="skill in featuredSkills" :key="skill.id">
            <ApplicantSkill v-if="isApplicantSkill(skill)" :applicant_id="payload.data.resource_id" :applicant_skill="skill" :inputType="true" @refresh="init" />
            <p v-else @click="addApplicantSkill(skill)" class="skill" :class="skill.markedInCV ? 'is-marked-cv' : ''">{{skill.name}}</p>
          </div>
        </div>
      </div>
      <div v-for="(fullSkill, category) in fullDataSkills" :key="category">
        <p><b>{{category}}</b></p>
        <div class="is-flex is-align-items-center is-flex-wrap-wrap">
          <div :class="{ underline: skill.underline }" v-for="skill in sortSkills(fullSkill.skills)" :key="skill.id">
            <ApplicantSkill v-if="isApplicantSkill(skill)" :applicant_id="payload.data.resource_id" :applicant_skill="skill" :inputType="true" @refresh="init" />
            <p v-else @click="addApplicantSkill(skill)" class="skill" :class="skill.markedInCV ? 'is-marked-cv' : ''">{{skill.name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// components
import BaseInput from '@/components/BaseInput.vue'
import ApplicantSkill from '@/components/shared/organisms/ApplicantSkill'
import ApplicantSuggestedPosition from '@/components/ApplicantSuggestedPosition'

export default {
  name: 'ApplicantSkillsForm',
  components: {
    ApplicantSkill,
    ApplicantSuggestedPosition,
    BaseInput
  },
  props: ['payload'],
  data () {
    return {
      searchSkill: '',
      applicantSkills: [],
      featured_skills: [],
      full_data_by_category: {},
      suggestedPositions: []
    }
  },
  computed: {
    fullDataSkills () {
      return this.deepSearch(this.full_data_by_category, this.searchSkill.toLowerCase())
    },
    featuredSkills () {
      return this.featured_skills.filter(el => el.name.toLowerCase().includes(this.searchSkill.toLowerCase()))
    },
    skillsWithComments () {
      return this.applicantSkills.filter(skill => skill.applicant_comment)
    }
  },
  created () {
    this.init()
  },
  methods: {
    deepSearch (obj, search) {
      return Object.fromEntries(Object.entries(this.full_data_by_category).reduce((prev, [key, val]) => {
        if (key.toLowerCase().includes(search)) {
          return [...prev, [key, val]]
        }
        const filtered_skills = val.skills.filter(e => {
          return e.name.toLowerCase().includes(search)
        })
        if (filtered_skills.length > 0) {
          return [...prev, [key, { ...val, skills: filtered_skills }]]
        }
        return prev
      }, []))
    },
    revokeSkills () {
      const promises = []
      this.applicantSkills.forEach(skill => {
        promises.push(this.$network_utils.updateApplicantSkill({ id: skill.id, current_applicant_id: this.payload.data.resource_id, revoked: true }))
      })
      Promise.all(promises).then(() => { this.init() })
    },
    init () {
      this.getFullSkills()
      this.getSuggestedPositions()
    },
    async getFullSkills () {
      const texts = await this.$network_utils.getResourceTexts({
        current_type: 'Applicant',
        current_resource_id: this.payload.data.resource_id
      })
      const cvText = texts.find(text => text.designator == 'outsource_cv_text')
      this.applicantSkills = await this.$network_utils.getApplicantSkills({ current_applicant_id: this.payload.data.resource_id })
      return this.$network_utils.getAllSkills({ sort: '-positions_prevalence' }).then(response => {
        const full_skills = response.map(skill => {
          const applicantSkill = this.applicantSkills.find(s => s.skill.id == skill.id)
          const test = new RegExp(skill.name.replace(/(\W)/g, '\\$1'), 'ig').test(cvText ? cvText.content : '')
          return { ...skill, ...(test && { markedInCV: true }), ...(applicantSkill && applicantSkill) }
        })
        this.featured_skills = this.sortSkills(full_skills.filter(full_skill => full_skill.featured))
        this.full_data_by_category = this.getDataByCategory(full_skills)
        this.full_data_by_category = this.sortCategories(this.full_data_by_category, this.positionsPrevalenceSort)
      })
    },
    addApplicantSkill (skill) {
      this.$network_utils.postApplicantSkill({ skill_id: skill.id, current_applicant_id: this.payload.data.resource_id }).then(() => {
        this.init()
      })
    },
    isApplicantSkill (skill) {
      return skill.skill != undefined
    },
    async setSkillsBooster () {
      try {
        await this.$network_utils.postEvent({ event: 'set_skills_booster', current_type: 'Applicant', current_resource_id: this.payload.data.resource_id })
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      } catch {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    },
    getDataByCategory (skills) {
      let skills_by_category = {}
      for (let i = 0; i < skills.length; i++) {
        let skill = skills[i]
        let category = skill.category == undefined ? skill.skill.category : skill.category
        if (skills_by_category[category] == undefined) {
          skills_by_category[category] = { skills: [] }
          skills_by_category[category].positions_prevalence = 0
          skills_by_category[category].display_category = category
        }
        skill.underline = (i <= 30)
        skills_by_category[category].skills.push(skill)
        skills_by_category[category].positions_prevalence += skill.positions_prevalence
      }
      return skills_by_category
    },
    sortSkills (skills) {
      return [...skills].sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    positionsPrevalenceSort (category_1, category_2) {
      return this.full_data_by_category[category_2].positions_prevalence - this.full_data_by_category[category_1].positions_prevalence
    },
    getSuggestedPositions () {
      this.$network_utils.getApplicantSuggestedPositions({
        applicant_id: this.payload.data.resource_id
      }).then(response => {
        this.suggestedPositions = response
      })
    },
    sortCategories (obj, sortFunction) {
      return Object.keys(obj)
        .sort(sortFunction)
        .reduce((acc, key) => ({ ...acc, [key]: obj[key] }), {})
    }
  }
}
</script>
<style>
  .underline p {
    text-decoration: underline;
  }
  .skill{
    cursor: pointer;
    margin: 0;
    margin-left: 10px;
  }
</style>
<style scoped>
  .suggested_positions{
    position: relative;
    width: 45%;
    min-width: 45%;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 30px;
    margin-left: 30px;
  }
  .is-marked-cv {
    background-color: yellow
  }
</style>
